<div id="frheader">
  <div class="content-container nav_desktop">
    <div class="pure-g">
      <div class="pure-u-11-24 pure-u-md-6-24 pure-u-xl-9-24">
        <div class="logo_sec">
          <div class="pure-u-14-24">
            <a class="pluslogo" routerLink="/fr/home" title="CSLB Plus logo">
              <!-- <img src="/assets/img/cslplus_logo.png." alt="CSLB Plus logo" class="" /> -->
            </a>
          </div>
          <div class="pure-u-4-24"></div>
          <div class="pure-u-4-24 langlink mobilehidden">
            <a routerLink="/home" title="English">English</a>
          </div>
        </div>
      </div>
      <div class="pure-u-13-24 pure-u-md-18-24 pure-u-xl-15-24">
        <div class="nav-tab mobilehidden">
          <p>Appelez-nous au <a href="tel:18884904105" title="tel:18884904105">1-888-490-4105</a></p>
          <span>|</span>
          <p>du lundi au vendredi, de 8 h à 16 h (HE)</p>
          <span>|</span>
          <p><a href="mailto:support@cslplus.ca" title="Envoyez-nous un courriel">Envoyez-nous un
              courriel</a></p>
        </div>
        <div class="nav_icon desktophidden">
          <a id="navhaem" href="javascript:void(0);" class="icon" (click)="navmobile()"
            [style.display]="navhaem ? 'block' : 'none'">
            <span id="navMobile"><span class="fa fa-bars" aria-hidden="true" id="hamburger"></span></span>
          </a>
        </div>
      </div>
    </div>

    <div class="pure-g mobilehidden">
      <div class="pure-u-1 menu_tab ">
        <ul>
          <li><a (click)="scroll('#patient_support_fr')" title="Patients">Patients</a></li>
          <li><a (click)="scroll('#HCPs_fr')" title="Professionnels De La Santé">PROFESSIONNELS DE LA Santé</a></li>
          <li><a (click)="scroll('#sec_cslnews')" title="Commander Des Fournitures">Commander Des Fournitures</a></li>
          <li><a (click)="scroll('#contact_us_fr')" title="Nous Joindre">Nous Joindre</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="pure-u-1 desktophidden mobile_nav_panel">
    <div id="myLinks" class="topnav content-container" [style.display]="myLinks ? 'block' : 'none'">
      <div class="img_wrapper">
        <div class="pure-u-18-24 idelvionlogo">
          <a class="pluslogo" routerLink="/fr/home" title="CSLB Plus logo">
            <img src="/assets/img/cslb-Plus-logo.svg" alt="CSLB Plus logo" class="" />
          </a>
        </div>
        <a id="" href="javascript:void(0);" class="pure-u-6-24" (click)="navmobile()">
          <span class="fa fa-close"></span>
        </a>
      </div>
      <div class="anchorwrapper">
        <ul>
          <li><a (click)="scroll('#patient_support_fr')" title="Patients">Patients</a></li>
          <li><a (click)="scroll('#HCPs_fr')" title="Professionnels De La Santé">PROFESSIONNELS DE LA Santé</a></li>
          <li><a (click)="scroll('#sec_cslnews')" title="Commander Des Fournitures">Commander Des Fournitures</a></li>
          <li><a (click)="scroll('#contact_us_fr')" title="Nous Joindre">Nous Joindre</a></li>
        </ul>
      </div>
      <div class="nav-tab-mobile">
        <div class="nav_wrapper">
          <p>Appelez-nous au <a href="tel:18884904105" title="tel:18884904105">1-888-490-4105</a></p>
          <p>du lundi au vendredi, de 8 h à 16 h (HE)</p>
          <p id="emaillink"><a href="mailto:support@cslplus.ca"
              title="Envoyez-nous un courriel">Envoyez-nous un courriel</a></p>
          <div class="langlink">
            <a routerLink="/home" title="English">English</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="banner_header">
    <div  class="pure-g">
      <div class="pure-u-1 pure-u-lg-1-24 pure-u-md-1-24 pure-u-xl-2-24"></div>
      <div class="pure-u-1 pure-u-lg-12-24 pure-u-md-11-24">
        <div class="content">
          <h1>
            Programme de soutien aux patients CSL PLUS<sup>&trade;</sup>
          </h1>
          <h2>
            Un programme de soutien personnalisé, conçu spécialement pour les patients.
          </h2>
          <p>
            CSL PLUS vise à fournir un soutien de la plus haute qualité grâce à un contact individuel avec notre équipe
            de gestionnaires de dossiers constituée d’infirmières autorisées qui sont là pour les patients à chaque
            étape du processus.
          </p>
          <!-- </div> -->
          
          
        </div>
      </div>
      <div class="pure-u-1 pure-u-lg-11-24 pure-u-md-12-24 pure-u-xl-10-24">
        <video class="hero_video" src="assets/hero_video.mp4" type="video/mp4" playsinline autoplay [muted]="true"></video>
      </div>
    </div>
  </div>
  <!-- <div class="content-container">
    <div class="pure-g">
      <div class="content">
        <div class="pure-u-1 pure-u-lg-1-24"></div>
        <div class="pure-u-1 pure-u-md-10-24">
          <h1>
            Programme de soutien aux patients CSL PLUS<sup>&trade;</sup>
          </h1>
          <h2>
            Un programme de soutien personnalisé, conçu spécialement pour les patients.
          </h2>
          <p>
            CSL PLUS vise à fournir un soutien de la plus haute qualité grâce à un contact individuel avec notre équipe
            de gestionnaires de dossiers constituée d’infirmières autorisées qui sont là pour les patients à chaque
            étape du processus.
          </p>
        </div>
        <div class="pure-u-1 pure-u-md-13-24"></div>
      </div>

    </div>

  </div> -->

</div>
<section class="programpillars" id="programpillars">
  <div class="content-container">
    <div class="pure-g">
      <div class="pure-u-1">
        <h2>
          LES PILIERS DU PROGRAMME :
        </h2>
      </div>

      <div class="programpillars_box_wrapper">

        <div class="pure-u-1 pure-u-md-7-24">
          <div class="section" [class.divsec]="divsec">
            <div class="image_wrapper">
              <div class="img_section">
                <img src="/assets/img/education_training_icon.png" alt="Patient Program"
                  [class.trainingImg]="trainingImg" />
              </div>
            </div>
            <div class="text" (click)="showState()" (mouseleave)="hidestate()">
              <p>ÉDUCATION ET FORMATION</p>
            </div>
            <div class="textstuff" [@widthGrow]="state" [class.testvisible]="testvisible">
              <ul>
                <li>
                  CSL PLUS offre une éducation, une formation et un soutien illimités aux patients et aux soignants
                </li>
              </ul>
              <div (click)="hidestate()" class="closewindow"><span class="fa fa-close"> </span>&nbsp;<span>Fermer la
                  fenêtre
                </span></div>
            </div>
          </div>
        </div>
        <div class="pure-u-1 pure-u-md-1-24"></div>
        <div class="pure-u-1 pure-u-md-7-24">
          <div class="section" [class.divsec2]="divsec2">
            <div class="image_wrapper">
              <div class="img_section">
                <img src="/assets/img/ongoing_support_icon.png" [class.supportImg]="supportImg"
                  alt="Patient Program" />
              </div>
            </div>
            <div class="text" (click)="showState2()" (mouseleave)="hidestate2()">
              <p>SUIVI ET SOUTIEN CONTINU</p>
            </div>
            <div class="textstuff2" [@widthGrow2]="state2" [class.testvisible2]="testvisible2">
              <ul>
                <li>
                  Inscription facile avec une expérience d’intégration rapide et harmonieuse
                </li>
                <li>Soutien individuel offert par une infirmière autorisée gestionnaire de dossier</li>
              </ul>
              <div (click)="hidestate2()" class="closewindow"><span class="fa fa-close"> </span>&nbsp;<span>Fermer la
                  fenêtre</span></div>
            </div>
          </div>
        </div>

        <div class="pure-u-1 pure-u-md-1-24"></div>
        <div class="pure-u-1 pure-u-md-7-24">
          <div class="section" [class.divsec3]="divsec3">
            <div class="image_wrapper">
              <div class="img_section">
                <img src="/assets/img/helthcare_suport_icon.png" [class.healthcareImg]="healthcareImg"
                  alt="Patient Program" />
              </div>
            </div>
            <div class="text" (click)="showState3()" (mouseleave)="hidestate3()">
              <p>SOUTIEN PAR DES PROFESSIONNELS DE LA SANTÉ</p>
            </div>
            <div class="textstuff3" [@widthGrow3]="state3" [class.testvisible3]="testvisible3">
              <ul>
                <li>
                  Un soutien personnalisé pour répondre aux besoins des patients, et une aide à l’inscription et au
                  suivi pour les professionnels de la santé
                </li>
                <li>Contact constant avec une infirmière dédiée à la gestion du dossier pour la totalité du parcours
                  de traitement</li>
              </ul>
              <div (click)="hidestate3()" class="closewindow"><span class="fa fa-close"> </span>&nbsp;<span>Fermer la
                  fenêtre</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="programpillars_text">
      <div class="pure-g">
        <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-5-24"></div>
        <div class="pure-u-1 pure-u-md-17-24 pure-u-lg-17-24">
          <h3>
            CSL Behring est un leader de la biotechnologie axé sur l’innovation et la fourniture de médicaments vitaux
            pour les patients ayant des besoins médicaux non satisfaits.
          </h3>
          <div class="">
            <div class="bullettext">
              <h4>
                offert pour les patients traités avec :
              </h4>
              <div class="bulletpoint">
                <div class="pure-g logoalignment">
                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <img src="/assets/img/hizentra-logo.svg" alt="Hizentra logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>

                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24 align-center">
                    <img src="/assets/img/humatep-logo.png" alt="Humatep logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>
                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24 align-center">
                    <img src="/assets/img/Hemgenix_Logo_FR.png" alt="Hemgenix logo icon" />
                  </div>
                </div>
                <div class="pure-g logoalignment">
                  <div class="pure-u-1 pure-u-md-7-24  pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <img src="/assets/img/berinert-logo.svg" alt="Berinert logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>

                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <img src="/assets/img/haegarda-logo.svg" alt="Haegarda logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>
                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <a href="https://www.andembry.ca/fr/home " target="_blank">
                      <img src="/assets/img/FR_AndembryLogo.png" alt="Andembry logo icon" />
                    </a>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="desktophidden tablethidden">
            <div class="bullettext-mob">
              <h4>
                Available for patients on:
              </h4>
              <div class="bulletpoint">
                <div class="pure-g">
                  <div class="pure-u-1">
                    <ul>
                      <li>
                        <span>Hizentra<sup>&reg;</sup></span><br>
                        Immunoglobuline sous-cutanée (humaine), 20%
                      </li>
                      <li>
                        <span>BERINERT<sup>&reg;</sup></span><br>
                        Inhibiteur de la C1 estérase (humaine)
                      </li>
                      <li>
                        <span>HUMATE-P<sup>&reg;</sup></span><br>
                        Complexe du facteur anti-hémophilique / facteur de von Willebrand (humain)
                      </li>
                      <li>
                        <span>HAEGARDA<sup>&reg;</sup></span><br>
                        Inhibiteur de la C1 estérase sous-cutané (humain)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</section>